import { ThemeTokens } from '../index';

export const neubrutalsimTokens: ThemeTokens = {
  name: 'neubrutalism',
  displayName: 'Brutal',
  description: 'Bold, raw, and unapologetically direct with stark contrasts',
  
  surface: {
    primary: '#ffffff',
    secondary: '#f0f0f0',
    tertiary: '#e0e0e0',
    elevated: '#ffffff',
    sunken: '#d0d0d0',
  },
  
  border: {
    width: '4px',
    radius: '0px',
    color: '#000000',
    style: 'solid',
  },
  
  shadow: {
    sm: '4px 4px 0 #000000',
    md: '6px 6px 0 #000000',
    lg: '8px 8px 0 #000000',
    inset: 'inset 4px 4px 0 rgba(0,0,0,0.1)',
  },
  
  typography: {
    fontFamily: '"Space Grotesk", "Inter", system-ui, sans-serif',
    headingWeight: '800',
    bodyWeight: '500',
    letterSpacing: '-0.02em',
  },
  
  card: {
    background: '#ffffff',
    border: '4px solid #000000',
    shadow: '8px 8px 0 #000000',
    padding: '20px',
    radius: '0px',
  },
  
  button: {
    primary: '#ffdd00',
    secondary: '#ffffff',
    border: '4px solid #000000',
    shadow: '4px 4px 0 #000000',
    radius: '0px',
    hoverTransform: 'translate(2px, 2px)',
  },
  
  effects: {
    texture: 'none',
    gradient: 'none',
    overlay: 'none',
  },
};

// Dark mode variant for neubrutalism
export const neubrutalsimDarkTokens: Partial<ThemeTokens> = {
  surface: {
    primary: '#1a1a1a',
    secondary: '#252525',
    tertiary: '#303030',
    elevated: '#2a2a2a',
    sunken: '#101010',
  },
  border: {
    width: '4px',
    radius: '0px',
    color: '#ffffff',
    style: 'solid',
  },
  card: {
    background: '#1a1a1a',
    border: '4px solid #ffffff',
    shadow: '8px 8px 0 #ffffff',
    padding: '20px',
    radius: '0px',
  },
  button: {
    primary: '#ffdd00',
    secondary: '#1a1a1a',
    border: '4px solid #ffffff',
    shadow: '4px 4px 0 #ffffff',
    radius: '0px',
    hoverTransform: 'translate(2px, 2px)',
  },
};

// Accent colors for neubrutalism
export const brutalAccents = {
  yellow: '#ffdd00',
  pink: '#ff6b9d',
  blue: '#00d4ff',
  green: '#00ff88',
  orange: '#ff8800',
  purple: '#b388ff',
};
